import {
  VALIDATION_LOCATION_CREATE,
  VALIDATION_LOCATION_CREATE_SUCCESS,
  VALIDATION_LOCATION_CREATE_FAILURE,
  VALIDATION_LOCATION_LIST,
  VALIDATION_LOCATION_LIST_SUCCESS,
  VALIDATION_LOCATION_LIST_FAILURE,
  VALIDATION_LOCATION_DELETE,
  VALIDATION_LOCATION_DELETE_SUCCESS,
  VALIDATION_LOCATION_DELETE_FAILURE,
  VALIDATION_LOCATION_CLEAR
} from '../actions/validation-location'

const initialState = {
  loading: false,
  error: null,
  data: [],
  message: null,
  reload: false
}

export default function validationLocationReducer(state = initialState, action) {
  switch (action.type) {
    case VALIDATION_LOCATION_LIST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null
      }
    case VALIDATION_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
        reload: false
      }
    case VALIDATION_LOCATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: null
      }
    case VALIDATION_LOCATION_CREATE:
      return {
        ...state,
        loading: true,
        error: null,
        message: null
      }
    case VALIDATION_LOCATION_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload.data],
        message: action.payload.message,
        error: null,
        reload: true
      }
    case VALIDATION_LOCATION_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: null
      }
    case VALIDATION_LOCATION_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        message: null
      }
    case VALIDATION_LOCATION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter(location => location.id !== action.payload.locationId),
        message: action.payload.message,
        error: null,
        reload: true
      }
    case VALIDATION_LOCATION_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: null
      }
    case VALIDATION_LOCATION_CLEAR:
      return {
        ...initialState
      }
    default:
      return state
  }
}
